import { render, staticRenderFns } from "./dropdown-list.vue?vue&type=template&id=1578d35b&scoped=true"
import script from "./dropdown-list.vue?vue&type=script&lang=ts"
export * from "./dropdown-list.vue?vue&type=script&lang=ts"
import style0 from "./dropdown-list.vue?vue&type=style&index=0&id=1578d35b&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578d35b",
  null
  
)

export default component.exports